// istanbul ignore file

enum Experiment {
    AgencyCompliancePortalAccess = 'AgencyCompliancePortalAccess',
    AgencyCompliancePortalPortfolioMirroring = 'AgencyCompliancePortalPortfolioMirroring',
    AgencyCompliancePortalPropertyDetails = 'AgencyCompliancePortalPropertyDetails',
    AgencyCompliancePortalDownloadEmail = 'AgencyCompliancePortalDownloadEmail',
    AgencyEntryMethod = 'AgencyEntryMethod',
    AgencyCompliancePortalCorporateDashboard = 'AgencyCompliancePortalCorporateDashboard',
    AgencyCompliancePortalAdvancedAnalytics = 'AgencyCompliancePortalAdvancedAnalytics',
    OverrideBookableServices = 'OverrideBookableServices',
    ManualComplianceDataCapture = 'ManualComplianceDataCapture',
    PropertyRequestEnrolmentV1 = 'PropertyRequestEnrolmentV1',
    AgencyCompliancePortalNotifications = 'AgencyCompliancePortalNotifications',
    SmartSmokeAlarm = 'SmartSmokeAlarm',
    AgencyCompliancePortalTimeline = 'AgencyCompliancePortalTimeline'
}

interface UserExperiments {
    AgencyCompliancePortalAccess: boolean;
    AgencyCompliancePortalPortfolioMirroring: boolean;
    AgencyCompliancePortalPropertyDetails: boolean;
    AgencyCompliancePortalDownloadEmail: boolean;
    AgencyEntryMethod: boolean;
    AgencyCompliancePortalCorporateDashboard: boolean;
    AgencyCompliancePortalAdvancedAnalytics: boolean;
    OverrideBookableServices: boolean;
    ManualComplianceDataCapture: boolean;
    PropertyRequestEnrolmentV1: boolean;
    AgencyCompliancePortalNotifications: boolean;
    SmartSmokeAlarm: boolean;
    AgencyCompliancePortalTimeline: boolean;
}

export { Experiment, UserExperiments };
